<div>
  <div class="breadcrumb-block">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name:'business-dashboard'}">Home</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Invite user</li>
      </ol>
    </nav>
  </div>
  <div class="manage-package-block">
    <div class="white-box">
      <div class="table-title pb-0">
          <div class="error-list" v-if="errorsMessage">
              <ul class="error-msg" >
                  <li v-for="(error,x) in errorsMessage" :key="x">
                      <div v-for="(err,i) in error" :key="i">
                          <p> {{err}}</p>
                        </div>
                  </li>
                </ul>
          </div>
        <h5><i class="fas fa-plus"></i> Invite User</h5>
      </div>
      <hr />
      <div class="manage-user-block">
        <div class="form-modified">
          
          <form action="#">
            <div class="form-group row">
              <div class="col-lg-4">
                  <label for="">Email address</label>
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'error-input' : errors['email'] }"
                    id="inputPassword"
                    placeholder="Enter Email Address"
                    v-model="InviteUser.Email"
                  />
                  <validation-error v-if="isError" :isError="isError" :errors="errors" :field="'email'" />
              </div>
             <div class="col-lg-4">
               <label for="">First name</label>
               <input type="text" class="form-control"  :class="{ 'error-input' : errors['firstName'] }" placeholder="Enter First Name" v-model="InviteUser.FirstName">
               <validation-error v-if="isError" :isError="isError" :errors="errors" :field="'firstName'" />
              </div>
             <div class="col-lg-4">
                <label for="">Last name</label>
                <input type="text" class="form-control"  :class="{ 'error-input' : errors['lastName'] }" placeholder="Enter Last Name" v-model="InviteUser.LastName">
                <validation-error v-if="isError" :isError="isError" :errors="errors" :field="'lastName'" />
              </div>
            </div>
            <div class="form-group">
              <button type="submit" :disabled="Disable.save" class="default-btn save-btn" @click.prevent="inviteUser">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
